import { FC } from "react";

import { InfoMessage, Spinner } from "@amphore-dev/amphore-lib";
import { FieldArray, useFormikContext } from "formik";
import { t } from "i18next";

import { TReportFormValues } from "@/types";

import { useReportForm } from "./ReportForm";
import { ReportProjectCard } from "./ReportProjectCard";

export const ReportBody: FC = () => {
	const { existingReport, isFinalized, tasksQuery } = useReportForm();
	const { values, setFieldValue } = useFormikContext<TReportFormValues>();

	if (tasksQuery.isLoading || tasksQuery.isFetching) {
		return <Spinner />;
	}

	if (tasksQuery.error) {
		return (
			<InfoMessage color="warning" className="mt-4">
				{t("reports.dataError")}
			</InfoMessage>
		);
	}

	if (!existingReport && !tasksQuery.data?.projects?.length) {
		return (
			<InfoMessage className="mt-4">{t("reports.noData")}</InfoMessage>
		);
	}

	return (
		<>
			<FieldArray name="projects">
				{() => (
					<div className="z-0 flex flex-col gap-4">
						{values.projects.map((project, index) => (
							<ReportProjectCard
								// Not the name: it's editable, and a key that
								// changes with every keystroke remounts the
								// card (focus lost, edit mode closed). A saved
								// report's sections have no id, but they're
								// never reordered: their index is stable.
								key={project.id ?? `section-${index}`}
								project={project}
								index={index}
								isFinalized={isFinalized}
								setFieldValue={setFieldValue}
							/>
						))}
					</div>
				)}
			</FieldArray>
		</>
	);
};
